import { FC } from 'react';
import { BrandLogo } from '@kontentino/ui';
import getSocialMediaTypeForBrandLogo from 'app/utils/getSocialMediaTypeForBrandLogo';

interface SummaryProfileHeaderProps {
  name?: string;
  logoSrc?: string;
  pageType?: number;
  periodLabel: string;
}

/**
 * Profile header (brand logo + name + date range) shared by the interactive
 * overview summary and the report/PDF overview summary.
 */
const SummaryProfileHeader: FC<SummaryProfileHeaderProps> = ({
  name,
  logoSrc,
  pageType,
  periodLabel,
}) => {
  return (
    <div className="tw-mb-4 tw-flex tw-items-center tw-gap-3">
      <BrandLogo
        size={40}
        name={name}
        src={logoSrc}
        socialMediaType={
          pageType != null
            ? getSocialMediaTypeForBrandLogo(pageType)
            : undefined
        }
      />
      <div>
        <p className="tw-text-base tw-font-semibold tw-text-grayscale-180">
          {name}
        </p>
        <p className="tw-text-sm tw-font-medium tw-text-grayscale-180">
          {periodLabel}
        </p>
      </div>
    </div>
  );
};

export default SummaryProfileHeader;
